// extracted by mini-css-extract-plugin
export default {"ApplicationMainDrawer__MenuContainer":"ApplicationMainDrawer_ApplicationMainDrawer__MenuContainer__ObqCl"};